module.exports = __webpack_public_path__ + "static/media/pin-controls.d3253824.svg";